<template>
  <div class="yht-bottom">
    <div class="yht-bottom_text">版权所有：南京市雨花台烈士陵园管理局</div>
    <div class="yht-bottom_text mt10">技术支持：同方知网数字出版技术股份有限公司</div>
  </div>
</template>

<script>
export default {
  name: 'bottom',
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  methods: {}
}
</script>

<style src="./index.css"></style>
